import client from "api/client";
import { INDIVIDUAL_USER_APP_MANAGEMENT } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IIndividualUserRepository } from "features/individualUsersManagement/domain/repositories/IIndividualUserRepository";
import { injectable } from "tsyringe";
import { IndividualUserRequestModel } from "./model/IndividualUserRequestModel";
import { IndividualUserResponseModel } from "./model/IndividialUserResponseModel";

@injectable()
export class IndividualUserImpl implements IIndividualUserRepository {
  async getList(
    params: IndividualUserRequestModel,
  ): Promise<ListBaseApiResponseModel<IndividualUserResponseModel>> {
    return await client?.get(INDIVIDUAL_USER_APP_MANAGEMENT.LIST, params);
  }

  async getDetail(
    params: IndividualUserRequestModel,
  ): Promise<BaseApiResponseModel<IndividualUserResponseModel>> {
    return await client?.get(INDIVIDUAL_USER_APP_MANAGEMENT.DETAIL, params);
  }

  async resetOtpUser(
    phone: string,
  ): Promise<BaseApiResponseModel<{ phone?: string; deleteOtpCount?: number }>> {
    return await client?.get(INDIVIDUAL_USER_APP_MANAGEMENT.RESET_OTP, { phone });
  }
}
